// SEO3-06: keep app launchers away from the visible mobile purchase controls.
if (!customElements.get('pdl-overlay-guard')) {
  customElements.define('pdl-overlay-guard', class extends HTMLElement {
    connectedCallback() {
      this.visibleTargets = new Set();
      this.observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) this.visibleTargets.add(entry.target);
          else this.visibleTargets.delete(entry.target);
        });
        this.toggleAttribute('data-buybox-visible', this.visibleTargets.size > 0);
        this.updateBody();
      });
      this.closest('.shopify-section')?.querySelectorAll(
        '.product-info__title, .product-price, .product-options, .js-product-form-main'
      ).forEach((element) => this.observer.observe(element));
    }

    disconnectedCallback() {
      this.observer?.disconnect();
      this.removeAttribute('data-buybox-visible');
      this.updateBody();
    }

    updateBody() {
      document.body.classList.toggle('pdl-buybox-visible',
        Boolean(document.querySelector('pdl-overlay-guard[data-buybox-visible]')));
    }
  });
}
